import api from './api';

export interface ItemAcordoFinanceiro {
  tipoAlocacao: string | undefined;
  quantidade: number | undefined;
  precoUnitario: number | undefined;
  valor: number | undefined;
  alocacao: number | undefined;
  itemRateavelContratoId?: string;
  id: string;
  indice: number;
}

export const getItenAcordoFinanceiroRequisicaoCompra = (id: string) =>
  api.get<ItemAcordoFinanceiro[]>(`itemAcordoFinanceiro/GetByRequisicaoId/${id}`);

export const incluirItemAcordoFinanceiroRequisicaoCompra = (id: string) =>
  api.put(`itemAcordoFinanceiro/IncluirByRequisicaoId/${id}`);

export const updateItemAcordoFinanceiroRequisicaoCompra = (record: string) =>
  api.put(`itemAcordoFinanceiro/Update`, record);

export const getItensRateaveisContratoId = (id: string) =>
  api.get(`itemAcordoFinanceiro/GetItensRateaveisContratoId/${id}`);

export const getItensRateaveisContratoIdOptions = (id: string) =>
  getItensRateaveisContratoId(id).then(itens =>
    (itens || []).map(item => {
      return {
        text: (item.codigoItemServico + ' - ' + item.itemNarrativa).toString(),
        value: item.id.toString(),
      };
    }),
  );

export const deletarItemAcordoFinanceiro = (id: string) => api.delete(`itemAcordoFinanceiro/${id}`);
